module.exports = __webpack_public_path__ + "static/scale-model-of-marine-exploration-center-in-st.-petersburg-florida-d7bdef1de83521464c9ccbe4de67c9ac.png";